<style scoped lang="less">
.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #fff;
	margin-bottom: 20px;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	button:last-child {
		background-color: #ff8300;
	}

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;
	.sclectlable {
		margin-right: 20px;
	}
}

.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}
.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 60px;
		// padding: 2px 0;
		font-size: 12px;
		background-color: #f41127;
	}
}

.addstras {
	.addstrascenter {
		.ridioslist {
			border: 1px solid #ccc;
			margin: 20px 0;

			.qustridios {
				background-color: #f2f2f2;
				font-size: 16px;
				padding-left: 10px;
			}
		}

		.qustiopn {
			display: flex;
			align-items: center;
			letter-spacing: 1px;
			margin: 10px;

			p {
				margin: 0 5px;
			}

			.chioce:nth-of-type(2) {
				text-decoration: underline;
				color: rgb(0, 0, 255);
				cursor: pointer;
			}

			div {
				margin-right: 5px;
			}
		}
	}
}

/deep/ .childdia {
	background-color: #eff2fa;

	.el-dialog__body {
		padding: 10px 20px !important;
	}

	.demo-ruleForm {
		margin: 0 0px;
		border-top: 1px solid rgb(112, 182, 3);
		background-color: #fff;
		padding: 20px 20px 0;
	}
}

.boxright {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 20px 0;
}

.chioscelist {
	width: 100%;
	padding-bottom: 20px;

	.chiose {
		width: 100%;
		border: 1px solid;
		height: 100px;
		border: 1px solid #ccc;
		border-radius: 5px;
		display: flex;
		flex-wrap: wrap;
		overflow: scroll;
		padding: 10px;
		p {
			margin: 0 5px;
		}
	}

	.chiose::-webkit-scrollbar {
		display: none;
	}

	.chiosetop {
		display: flex;
		align-items: center;
		margin-bottom: 10px;

		p:first-child {
			margin-right: 10px;
		}
	}
}
</style>
<template>
	<div ref="homes">
		<!-- <div class="manageselect">
			<div class="sclectlable">
				<div>
					<el-select clearable v-model="pagesobj.pro_guid" placeholder="请选择专业" @change="getpolist()">
						<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div>
					<el-select clearable v-model="pagesobj.PR_GUID" placeholder="请选择岗位">
						<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
					</el-select>
				</div>
			</div>

			<div class="sclectlable">
				<div>
					<el-select clearable v-model="pagesobj.IL_GUID" placeholder="请选择等级">
						<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
					</el-select>
				</div>
			</div>

			<div class="primarybtn"><el-button @click="gerlists()" type="primary" icon="el-icon-search">搜索</el-button></div>
		</div> -->
		<div class="resourbtn"><el-button type="primary" size="small" icon="fa fa-plus" @click="addeaxmins">选择试卷</el-button></div>
		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnum" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table
							ref="tabslishad"
							@select="handleSelectionChange"
							@select-all="handleSelectionChangeall"
							:data="tableData"
							header-row-class-name="tablestitle"
							border
							style="width: 100%"
						>
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column label="试卷名称" prop="SPA_PaperTitle"></el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesobj.pageSize }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getGetProfList, getPositionList, changeGradeGet, GetTestPaperList } from '@/request/api/homesview/yunhomes/yunhom.js';

import { GetzyProfList } from '@/request/api/mange/mange.js';

import $ from 'jquery';
import AppOptions from '@/config/AppOptions.vue';
export default {
	data() {
		return {
			tabsnum: 10,
			totalall: 10,
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				PCR_GUID: '',
				PR_GUID: '',
				SPA_PaperTitle: '',
				IL_GUID: '',
				pro_guid: ''
			},
			prolist: [],
			polist: [],
			gradeget: [],
			ruleForm: {
				SPA_PaperTitle: '',
				SPA_Duration: '',
				PR_GUID: '',
				CA_GUID: '',
				IL_GUID: '',
				SKY_GUID: '',
				ridios: '0'
			},
			tableData: [],
			isexamines: {},
			ruleFormc: {}
		};
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		if (AppOptions.appEmpty) {
			let homestop = $(this.$refs.homes).offset().top;
			let homesleft = $(this.$refs.homes).offset().left;
			if (homestop < 25 && localStorage.getItem('token') && homesleft < 200) {
				// console.log("刷新页面")
				// if (localStorage.getItem('token')) {
				// 	window.location.reload();
				// }
			}
		}
		
		this.ruleFormc = this.ruleFormchildren;
		this.init();
	},
	props: {
		ruleFormchildren: {
			default: Object
		},
		ischioceitem: {
			default: Object
		}
	},
	watch: {
		ruleFormchildren(val) {
			// console.log(val, '获取注入');
			this.ruleFormc = val;
			this.init();
		},
		ischioceitem(val) {
			this.ischioceitem = val;
		}
	},
	inject: ['fatherMethod'],
	methods: {
		// 添加试卷
		addeaxmins() {
			// 添加事件
			this.fatherMethod(this.isexamines);
		},
		handleCloses(done) {
			done();
		},
		init() {
			// console.log('获取tables',this.pagesobj,this.ruleFormc)
			this.pagesobj.pro_guid = this.ruleFormc.CA_GUID;
			this.pagesobj.PR_GUID = this.ruleFormc.PR_GUID;
			this.pagesobj.IL_GUID = this.ruleFormc.IL_GUID;
			this.gerlists();
		},
		changetablesize() {
			// console.log(this.pagesobj.pageSize);
			this.pagesobj.pageSize = Number(this.tabsnum);
			this.gerlists();
		},
		// 选择
		handleSelectionChange(list, row) {
			// 单选
			// console.log(this.tableData, row);
			if (list.length > 0) {
				this.$refs.tabslishad.clearSelection();
				this.$refs.tabslishad.toggleRowSelection(row);
				this.isexamines = row;
			}
		},
		handleSelectionChangeall(list) {
			// 多选
			this.$refs.tabslishad.clearSelection();
			if (list.length > 0) {
				this.$refs.tabslishad.toggleRowSelection(list[0]);
				this.isexamines = list[0];
			}
		},
		gerlists() {
			GetTestPaperList(this.pagesobj).then(res => {
				// console.log(res)
				if (res.data.code > 0) {
					this.tableData = res.data.data.list;
					this.totalall = res.data.data.totalCount;
					if (this.ischioceitem) {
						this.$nextTick(() => {
							this.$refs.tabslishad.toggleRowSelection(this.ischioceitem,true);
						});
						// console.log('获取tables1213', this.ischioceitem,this.$refs.tabslishad.toggleRowSelection);
					}
				} else {
					this.tableData = [];
					this.totalall = 0;
				}
			});
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(() => {
					done();
				})
				.catch(() => {});
		},
		indexMethod(index) {
			return index + 1;
		},
		changecurr(val) {
			this.pagesobj.pageIndex = val;
			this.gerlists();
		}
	}
};
</script>
